import { defineNuxtRouteMiddleware } from 'nuxt/app';
import type { RouteLocationNormalized } from 'vue-router';

import { BRAND_PAGE_URL } from '@/constants/url.const';
import { redirectTo } from '@/utils/common.util';

export default defineNuxtRouteMiddleware(async (_to: RouteLocationNormalized) => {
  return await redirectTo(BRAND_PAGE_URL);
});
